module.exports = __webpack_public_path__ + "img/productInStock.0364ec4f.svg";